<script>
import axios from "axios";
import Vue from "vue";
import {env} from "@/state/helpers";

export default {
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    userType() {
      return this.$store.getters['user/userType']
    },
  },
  methods: {
    async downloadCampaignReport(type) {
      try {
        this.$store.commit('loader/START_LOADING');
        await axios.post(`/${this.userType}/campaign/${this.campaign._id}/report`, {}, { params: { type } });

        Vue.swal({
          position: "top-end",
          icon: "success",
          title: "We will send you an email with the report once it's ready.",
          showConfirmButton: false,
          timer: 4000
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadCampaignPlan(type) {
      try {
        this.$store.commit('loader/START_LOADING');
        await axios.post(`/${this.userType}/campaign/${this.campaign._id}/plan/report`, {}, { params: { type } });

        Vue.swal({
          position: "top-end",
          icon: "success",
          title: "We will send you an email with the report once it's ready.",
          showConfirmButton: false,
          timer: 4000
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async downloadCampaignOffers(type) {
      if (type === 'pdf') {
        try {
          this.$store.commit('loader/START_LOADING');
          await axios.post(`/${this.userType}/campaign/${this.campaign._id}/offer/report?type=pdf`, {}, { params: { type } });

          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "We will send you an email with the report once it's ready.",
            showConfirmButton: false,
            timer: 4000
          });
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      } else {
        const baseUrl = env('VUE_APP_API_URL');
        await window.open(`${baseUrl}/${this.userType}/campaign/${this.campaign._id}/offers-to-influencers/report`, '_self');
      }
    },
    async downloadCampaignAddressInfo() {
      const baseUrl = env('VUE_APP_API_URL');
      window.open(`${baseUrl}/${this.userType}/campaign/${this.campaign._id}/delivery-info/report`, '_self');
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="media">
        <div class="mr-3">
          <img v-if="campaign.image_url" :src="`${campaign.image_url}`" alt class="avatar-sm" />
          <div v-else class="avatar-xs letter-in-circle-2" :style="{background: campaign.color}">{{ campaign.internal_name.charAt(0) }}</div>
        </div>
        <div class="media-body align-self-center">
          <div class="text-muted">
            <h5>{{ campaign.internal_name }}</h5>
            <p class="mb-1">{{ this.campaign.start_date | localeTimeString }} - {{ this.campaign.end_date | localeTimeString }}</p>
            <p class="mb-0">{{ this.campaign.hashtag_identifier }}</p>
          </div>
        </div>
        <b-dropdown right variant="primary">
          <template slot="button-content">
            <i class="fas fa-file-download mr-1"></i>
            Download
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item @click="downloadCampaignReport('pdf')">Campaign Report - PDF</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignReport('xlsx')">Campaign Report - XLSX</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignPlan('pdf')">Campaign Plan - PDF</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignPlan('xlsx')">Campaign Plan - XLSX</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignOffers('pdf')">Campaign offers - PDF</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignOffers('xlsx')">Campaign offers - XLSX</b-dropdown-item>
          <b-dropdown-item @click="downloadCampaignAddressInfo">Campaign Address Info - PDF</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>
